import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-400">
        Laden…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "voertuig" ? "/voertuig" : "/dashboard"} replace />;
  }
  return children;
}
